
import Vue from 'vue';
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(
    'section',
    { staticClass: 'a404page' },
    [
      _c('secondary-nav'),
      _c(
        'div',
        { staticClass: 'su-body' },
        [
          _c('div', { staticClass: 'su-section-seven container su-section-contact' }, [
            _c('div', { staticClass: 'row' }, [
              _c('div', { staticClass: 'col-1 void-column' }),
              _c('div', { staticClass: 'col-12 col-md-11' }, [
                Number(_vm.form.position) !== 0
                  ? _c('div', { staticClass: 'row' }, [
                      _c('div', { staticClass: 'col-12' }, [
                        _c('p', [_vm._v('Become our')]),
                        _c(
                          'h1',
                          { staticClass: 'd-flex align-items-center flex-row' },
                          [
                            _vm._v(
                              ' ' + _vm._s(_vm.availablePositions[_vm.form.position].name) + ' ',
                            ),
                            _vm.loadingFormRequest
                              ? _c('b-spinner', {
                                  staticClass: 'ml-3',
                                  attrs: { type: 'grow', label: 'Loading' },
                                })
                              : _vm._e(),
                          ],
                          1,
                        ),
                        _c('p', {
                          staticClass: 'mb-5',
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.availablePositions[_vm.form.position].description,
                            ),
                          },
                        }),
                      ]),
                    ])
                  : _vm._e(),
                _c(
                  'form',
                  {
                    staticClass: 'row',
                    on: {
                      submit: function ($event) {
                        $event.preventDefault();
                        return _vm.submitEntry.apply(null, arguments);
                      },
                    },
                  },
                  [
                    _c('div', { staticClass: 'col-md-6 col-12' }, [
                      _c('div', { staticClass: 'form-group' }, [
                        _c('label', { attrs: { for: 'name' } }, [_vm._v('Select position*')]),
                        _c(
                          'select',
                          {
                            directives: [
                              {
                                name: 'model',
                                rawName: 'v-model',
                                value: _vm.form.position,
                                expression: 'form.position',
                              },
                            ],
                            staticClass: 'form-control',
                            class: { 'su-error-field': _vm.msg.position.length },
                            attrs: {
                              id: 'position',
                              name: 'position',
                              disabled: _vm.loadingFormRequest,
                            },
                            on: {
                              change: [
                                function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected;
                                    })
                                    .map(function (o) {
                                      var val = '_value' in o ? o._value : o.value;
                                      return val;
                                    });
                                  _vm.$set(
                                    _vm.form,
                                    'position',
                                    $event.target.multiple ? $$selectedVal : $$selectedVal[0],
                                  );
                                },
                                function ($event) {
                                  _vm.msg.position = '';
                                },
                              ],
                            },
                          },
                          [
                            _c('option', { attrs: { disabled: '', value: '0' } }, [
                              _vm._v('Please select one'),
                            ]),
                            _c('option', { attrs: { value: '1' } }, [_vm._v('Singer Dancer')]),
                            _c('option', { attrs: { value: '2' } }, [_vm._v('Singer')]),
                            _c('option', { attrs: { value: '3' } }, [_vm._v('Dancer')]),
                            _c('option', { attrs: { value: '4' } }, [_vm._v('Musician')]),
                          ],
                        ),
                        _vm.msg.position.length
                          ? _c('span', { staticClass: 'su-error-field-text' }, [
                              _vm._v(_vm._s(_vm.msg.position)),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                    _c('div', { staticClass: 'col-md-6 col-12' }, [
                      _c('div', { staticClass: 'form-group' }, [
                        _c('label', { attrs: { for: 'name' } }, [_vm._v('Complete name*')]),
                        _c('input', {
                          directives: [
                            {
                              name: 'model',
                              rawName: 'v-model',
                              value: _vm.form.name,
                              expression: 'form.name',
                            },
                          ],
                          staticClass: 'form-control',
                          class: { 'su-error-field': _vm.msg.name.length },
                          attrs: {
                            id: 'name',
                            name: 'name',
                            placeholder: 'Enter name here...',
                            type: 'text',
                            disabled: _vm.loadingFormRequest,
                          },
                          domProps: { value: _vm.form.name },
                          on: {
                            change: function ($event) {
                              _vm.msg.name = '';
                            },
                            input: function ($event) {
                              if ($event.target.composing) return;
                              _vm.$set(_vm.form, 'name', $event.target.value);
                            },
                          },
                        }),
                        _vm.msg.name.length
                          ? _c('span', { staticClass: 'su-error-field-text' }, [
                              _vm._v(_vm._s(_vm.msg.name)),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                    _c('div', { staticClass: 'col-md-6 col-12' }, [
                      _c('div', { staticClass: 'form-group' }, [
                        _c('label', { attrs: { for: 'email' } }, [_vm._v('Email*')]),
                        _c('input', {
                          directives: [
                            {
                              name: 'model',
                              rawName: 'v-model',
                              value: _vm.form.email,
                              expression: 'form.email',
                            },
                          ],
                          staticClass: 'form-control',
                          class: { 'su-error-field': _vm.msg.email.length },
                          attrs: {
                            id: 'email',
                            name: 'email',
                            placeholder: 'Enter email here',
                            type: 'text',
                            disabled: _vm.loadingFormRequest,
                          },
                          domProps: { value: _vm.form.email },
                          on: {
                            change: function ($event) {
                              _vm.getImages;
                              _vm.msg.email = '';
                            },
                            input: function ($event) {
                              if ($event.target.composing) return;
                              _vm.$set(_vm.form, 'email', $event.target.value);
                            },
                          },
                        }),
                        _vm.msg.email.length
                          ? _c('span', { staticClass: 'su-error-field-text' }, [
                              _vm._v(_vm._s(_vm.msg.email)),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                    _c('div', { staticClass: 'col-md-6 col-12' }, [
                      _c('div', { staticClass: 'form-group su-file' }, [
                        _c('p', { attrs: { for: 'email' } }, [_vm._v('Curriculum Vitae*')]),
                        _c('label', { attrs: { for: 'file' } }, [
                          _vm._v(
                            _vm._s(_vm.form.fileName != '' ? _vm.form.fileName : 'Select file...'),
                          ),
                        ]),
                        _c('input', {
                          ref: 'file',
                          staticClass: 'form-control',
                          class: { 'su-error-field': _vm.msg.cv.length },
                          attrs: {
                            id: 'file',
                            name: 'file',
                            placeholder: 'CV',
                            type: 'file',
                            disabled: _vm.loadingFormRequest,
                            accept:
                              '.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                          },
                          on: {
                            change: function ($event) {
                              _vm.getFileName();
                              _vm.msg.cv = '';
                            },
                          },
                        }),
                        _vm.msg.cv.length
                          ? _c('span', { staticClass: 'su-error-field-text' }, [
                              _vm._v(_vm._s(_vm.msg.cv)),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                    _c('div', { staticClass: 'col-md-6 col-12' }, [
                      _c('div', { staticClass: 'form-group su-file' }, [
                        _c('p', { attrs: { for: 'email' } }, [_vm._v('Images to attach*')]),
                        _c('label', { attrs: { for: 'images' } }, [
                          _vm._v(
                            _vm._s(
                              _vm.images.length > 0
                                ? _vm.images.length + ' image/es selected.'
                                : 'Select images...',
                            ),
                          ),
                        ]),
                        _c('input', {
                          ref: 'images',
                          staticClass: 'form-control',
                          class: { 'su-error-field': _vm.msg.images.length },
                          attrs: {
                            id: 'images',
                            name: 'images',
                            placeholder: 'Images',
                            type: 'file',
                            disabled: _vm.loadingFormRequest,
                            accept: '.jpg, .png, .jpeg',
                            multiple: '',
                          },
                          on: {
                            change: function ($event) {
                              _vm.getImages();
                              _vm.msg.images = '';
                            },
                          },
                        }),
                        _vm.msg.images.length
                          ? _c('span', { staticClass: 'su-error-field-text' }, [
                              _vm._v(_vm._s(_vm.msg.images)),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                    _c('div', { staticClass: 'col-md-6 col-12' }, [
                      _c('div', { staticClass: 'form-group' }, [
                        _c('label', { attrs: { for: 'email' } }, [
                          _vm._v('Send us your showreel*'),
                        ]),
                        _c('input', {
                          directives: [
                            {
                              name: 'model',
                              rawName: 'v-model',
                              value: _vm.form.url,
                              expression: 'form.url',
                            },
                          ],
                          staticClass: 'form-control',
                          class: { 'su-error-field': _vm.msg.url.length },
                          attrs: {
                            id: 'url',
                            name: 'url',
                            placeholder: 'Enter your showreel link here',
                            type: 'text',
                            disabled: _vm.loadingFormRequest,
                          },
                          domProps: { value: _vm.form.url },
                          on: {
                            change: function ($event) {
                              _vm.getImages;
                              _vm.msg.url = '';
                            },
                            input: function ($event) {
                              if ($event.target.composing) return;
                              _vm.$set(_vm.form, 'url', $event.target.value);
                            },
                          },
                        }),
                        _vm.msg.url.length
                          ? _c('span', { staticClass: 'su-error-field-text' }, [
                              _vm._v(_vm._s(_vm.msg.url)),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                    _c('div', { staticClass: 'col-md-6 col-12' }, [
                      _c('label', { attrs: { for: 'submit' } }, [_vm._v('Submit request')]),
                      _c('div', { staticClass: 'form-group' }, [
                        _c(
                          'button',
                          {
                            staticClass: 'su-button',
                            attrs: {
                              name: 'submit',
                              type: 'submit',
                              disabled: _vm.loadingFormRequest,
                            },
                          },
                          [_vm._v(' Send request now ')],
                        ),
                      ]),
                    ]),
                    _c(
                      'div',
                      { staticClass: 'col-md-6 col-12 d-flex justify-content-center flex-column' },
                      [
                        _c('div', { staticClass: 'form-group' }, [
                          _c(
                            'div',
                            { staticClass: 'custom-control custom-checkbox custom-control-inline' },
                            [
                              _c('input', {
                                directives: [
                                  {
                                    name: 'model',
                                    rawName: 'v-model',
                                    value: _vm.form.privacy,
                                    expression: 'form.privacy',
                                  },
                                ],
                                staticClass: 'custom-control-input',
                                class: { 'su-error-field': _vm.msg.privacy.length },
                                attrs: {
                                  name: 'terms',
                                  id: 'terms',
                                  type: 'checkbox',
                                  value: 'terms',
                                  disabled: _vm.loadingFormRequest,
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.form.privacy)
                                    ? _vm._i(_vm.form.privacy, 'terms') > -1
                                    : _vm.form.privacy,
                                },
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$a = _vm.form.privacy,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false;
                                      if (Array.isArray($$a)) {
                                        var $$v = 'terms',
                                          $$i = _vm._i($$a, $$v);
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            _vm.$set(_vm.form, 'privacy', $$a.concat([$$v]));
                                        } else {
                                          $$i > -1 &&
                                            _vm.$set(
                                              _vm.form,
                                              'privacy',
                                              $$a.slice(0, $$i).concat($$a.slice($$i + 1)),
                                            );
                                        }
                                      } else {
                                        _vm.$set(_vm.form, 'privacy', $$c);
                                      }
                                    },
                                    function ($event) {
                                      _vm.msg.privacy = '';
                                    },
                                  ],
                                },
                              }),
                              _vm._m(0),
                            ],
                          ),
                          _c('div', [
                            _vm.msg.privacy.length
                              ? _c('span', { staticClass: 'su-error-field-text' }, [
                                  _vm._v(_vm._s(_vm.msg.privacy)),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._m(1),
                        ]),
                      ],
                    ),
                    _c(
                      'label',
                      {
                        staticClass: 'col-12 image-preview-component',
                        class: { showImagePreview: _vm.images.length > 0 },
                        attrs: { for: 'imagesPreview' },
                      },
                      [_vm._v(' Attachments ')],
                    ),
                    _c(
                      'div',
                      {
                        staticClass: 'image-preview-row image-preview-component',
                        class: { showImagePreview: _vm.images.length > 0 },
                        attrs: { id: 'imagesPreview' },
                      },
                      [
                        _c('div', { staticClass: 'col-1 void-column' }),
                        _c(
                          'div',
                          { staticClass: 'col-md-10 col-12 row justify-content-center' },
                          _vm._l(_vm.urls, function (url, index) {
                            return _c(
                              'div',
                              {
                                key: index,
                                staticClass: 'col-md-4 col-12 image-preview-container',
                              },
                              [
                                _c(
                                  'button',
                                  {
                                    staticClass: 'delete-image-preview',
                                    attrs: { disabled: _vm.loadingFormRequest, type: 'button' },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteImage(index);
                                      },
                                    },
                                  },
                                  [_vm._v(' Delete ')],
                                ),
                                _c('img', { staticClass: 'image-preview', attrs: { src: url } }),
                              ],
                            );
                          }),
                          0,
                        ),
                        _c('div', { staticClass: 'col-1 void-column' }),
                      ],
                    ),
                  ],
                ),
              ]),
            ]),
          ]),
          _c('footer-row'),
          _c('alert-row', { ref: 'alertMsg' }),
        ],
        1,
      ),
    ],
    1,
  );
};
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c;
    return _c('label', { staticClass: 'custom-control-label', attrs: { for: 'terms' } }, [
      _vm._v(' Agree to the '),
      _c('a', { attrs: { href: '/privacy-policy' } }, [_vm._v('Privacy Policy')]),
      _vm._v('* '),
    ]);
  },
  function () {
    var _vm = this,
      _c = _vm._self._c;
    return _c('div', { staticClass: 'required_fields_label' }, [
      _c('label', [_vm._v('*Required fields')]),
    ]);
  },
];

export default Vue.extend({ render, staticRenderFns });
